import { PlusCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import React, { useState } from 'react';
import ButtonJumpCalendar from "../../../../components/Basic/ButtonJumpCalendar";
import Icon, { ICON_NAME } from "../../../../components/Icon";
import { openPopup } from "../../../../components/Popup/_components/WrapperPopup";
import { selectPermissions } from "../../../../util/store/selectors";
import { useSelector } from "../../../../util/store/store";
import { CALENDAR_VIEW } from "../../../../util/varibles/constants";
import { ACTION } from "../../../../util/varibles/permission";
import CalendarViewSelect from "../../_components/CalendarViewSelect";
import { CALENDAR_ID } from "../../constants";
import PopupChangesLog from "../../Popup/ChangeLog";
import PopupVessels from "../../Popup/Vessels";
import RemoveOps from "./RemoveOps";
import SendPlans from "./SendPlans";
import styles from "./style.module.scss";
import VesselFilter from "./VesselFilter";

const SpotVessel = () => {
    const [canSpotVessel] = useSelector(selectPermissions([ACTION.PLAN_OP.SPOT_VESSEL]));

    if (!canSpotVessel)
        return null;

    const handleClickSpotVessel = () => {
        const el = openPopup(<PopupVessels
            onClose={() => el.remove()}
        />)
    }

    return <Tooltip title="Spot vessel">
        <div className='bt-ghost' data-icon="true" onClick={handleClickSpotVessel}>
            <PlusCircleOutlined style={{ fontSize: '18px' }} />
        </div>
    </Tooltip>
}

const HeaderComponent: React.FC<{ calendarView: CALENDAR_VIEW }> = ({ calendarView }) => {
    const [changeLog, setChangeLog] = useState(false);

    const openChangeLog = () => {
        if (changeLog)
            return;

        setChangeLog(true)
        const el = openPopup(<PopupChangesLog
            onClose={() => {
                setChangeLog(false)
                el.remove()
            }}
        />)
    }

    return <div className={styles['view-header']}>
        <div className={styles['header-left']}>
            <CalendarViewSelect />
        </div>
        <div className={styles['header-right']}>
            <ButtonJumpCalendar
                calenderId={CALENDAR_ID}
                calendarView={calendarView}
                getHeightWeek={() => 840}
            />
            <VesselFilter />
            {/* <div className='bt-ghost h-32' onClick={openExportPopup}>
                <FilePdfOutlined className={styles['export-pdf']} />
                <span>Pdf/Excel file</span>
            </div> */}
            <div className='bt-ghost h-32' onClick={openChangeLog}>
                <Icon icon={ICON_NAME.CHANGES_LOG} />
                <span>Changes log</span>
            </div>
            <SendPlans>
                <RemoveOps />
                <SpotVessel />
            </SendPlans>
        </div>
    </div>;
};

export default HeaderComponent;
